import { Component, OnInit, Input } from '@angular/core';
import { LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-full-page-message',
  templateUrl: './full-page-message.component.html',
  styleUrls: ['./full-page-message.component.scss']
})
export class FullPageMessageComponent implements OnInit {
  @Input() message = '';
  constructor(public localService: LocalService) { }

  ngOnInit(): void {
  }

}
